<template>
  <div>
    <kpi-item
      title="Language combinations"
      v-model="params"
      type="language"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :lsp-list="lspList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
    />
    <kpi-item
      title="Industry sectors"
      v-model="params"
      type="industry"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :lsp-list="lspList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
    />
    <kpi-item
      title="Document types"
      v-model="params"
      type="document"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :lsp-list="lspList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
    />
    <kpi-item
      title="QA models"
      v-model="params"
      type="qa"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :lsp-list="lspList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
    />
    <kpi-item
      title="Evaluation methods"
      v-model="params"
      type="evaluation"
      :languages-list="languagesList"
      :qa-methods-list="qaMethodsList"
      :qa-models-list="qaModelsList"
      :lsp-list="lspList"
      :text-category-list="textCategoryList"
      :industry-field-list="industryFieldList"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Api from '../../../../utils/api';

export default Vue.extend({
  components: {
    'kpi-item': () => import('./kpiItems/index.vue'),
  },
  data: () => ({
    loading: true,

    textCategoryList: Array(),
    industryFieldList: Array(),
    languagesList: Array(),
    qaMethodsList: Array(),
    qaModelsList: Array(),
    lspList: Array(),

    params: {
      creation_date: Array(),
      industry_field: Array(),
      doc_type: Array(),
      sourceLanguage: null,
      targetLanguage: null,
      lsp: null,
      qaModel: Array(),
      qaMethod: Array(),
    },
  }),
  methods: {
    getFilters() {
      return Promise.all([
        this.$store.dispatch('GET_LANGUAGES').then((data) => {
          this.languagesList = [...data];
          this.languagesList.unshift({
            ID: '',
            LanguageName: ' All',
            CountryISOCode: 'world',
          });
        }),
        this.$store.dispatch('GET_INDUSTRY').then((data) => {
          this.industryFieldList = [...data];
        }),
        this.$store.dispatch('GET_DOCUMENT_TYPES').then((data) => {
          this.textCategoryList = [...data];
        }),
        this.$store.dispatch('GET_QA_METHODS').then((data) => {
          this.qaMethodsList = [...data];
        }),
        Api.getEvaluationMethods().then((resp) => {
          if (resp.data.Status) {
            this.qaModelsList = [...resp.data.Data];
          }
        }),
        Api.user.getLsp().then((resp) => {
          if (resp.data.Status) {
            this.lspList = [...resp.data.Data].map((el) => ({
              ID: el.ID,
              Name: el.Username,
            }));
          }
        }),
      ]);
    },
  },
  created() {
    this.getFilters().then(() => {
      this.loading = false;
    });
  },
});
</script>

<style lang="scss" scoped>
</style>
